import TokenCookie from '../services/TokenCookie'
import api from '../connectors/Api'

const API = api()

let initAuth = false
if (TokenCookie.exists()) {
  initAuth = true
}

export default {
  namespaced: true,
  state: {
    isAuth: initAuth,
    logoutInProgress: false
  },
  mutations: {
    setIsAuth (state, status) {
      state.isAuth = status
    },
    setLogoutInProgress (state, flag) {
      state.logoutInProgress = flag
    }
  },
  getters: {
    isAuthenticated (state) {
      return state.isAuth
    }
  },
  actions: {
    getAccessToken ({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (TokenCookie.exists()) {
          const cookie = TokenCookie.get()
          if (!TokenCookie.isCorrect()) {
            API.refreshToken(cookie.token)
              .then((res) => {
                TokenCookie.setFromResponse(res.body)
                commit('setIsAuth', true)

                resolve(res.body.access_token)
              })
              .catch((e) => {
                TokenCookie.remove()
                commit('setIsAuth', false)

                reject(new Error("Can't refresh access token"))
              })
          } else {
            resolve(cookie.token)
          }
        } else {
          commit('setIsAuth', false)

          reject(new Error('No access token'))
        }
      })
    },
    login ({ commit, state }, { login, password, rememberMe }) {
      return new Promise((resolve, reject) => {
        API.login(login, password)
          .then((res) => {
            TokenCookie.setFromResponse(res.body, rememberMe)
            commit('setIsAuth', true)
            resolve(res.body.access_token)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    logout ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('getAccessToken')
          .then((token) => {
            commit('setLogoutInProgress', true)

            API.logout(token)
              .then((res) => {
                TokenCookie.remove()
                commit('setIsAuth', false)
                resolve('logout')
              })
              .catch((e) => reject(e))
              .finally(() => {
                commit('setLogoutInProgress', false)
              })
          })
          .catch((e) => reject(e))
      })
    }
  }
}
